<div class="workspacePopup">
  <div class="trialCont">
    <div class="img">
      <img src="assets/images/html/facebook-personal-account.svg" alt="Workspace" />
    </div>
    <div class="textCont">
      <h1>
        Create Your Workspace
        <span
          data-toggle="tooltip"
          pTooltip="This will be billable"
          tooltipPosition="top"
          role="button"
          ><i class="pi pi-info-circle info-icon"></i
        ></span>
      </h1>
      <p>
        A workspace allows you to manage one Twitter account (Premium only), one Facebook page, one
        Instagram business account, one Threads account, one LinkedIn page (Premium only), one
        TikTok account, one YouTube channel, and one Pinterest account.<br />
      </p>
      <p>
        A workspace is ideal for managing a product, company, brand, client or services social media
        presence.
      </p>
    </div>
  </div>

  <app-loader [isLoading]="preventAbuse">
    <form [formGroup]="workSpaceForm">
      <div class="userForm">
        <div class="inputWrap">
          <small class="p-error" *ngIf="errorMessage">{{ errorMessage }}</small>

          <label for="workspace">Workspace Name</label>
          <input
            id="workspace"
            formControlName="workspace"
            class="inputText"
            type="text"
            pInputText
            maxlength="50"
          />
          <small
            class="p-error"
            *ngIf="workSpaceForm.dirty && workSpaceForm.get('workspace')?.errors"
          >
            Workspace name is required. (max 50 characters)</small
          >
        </div>
        <div class="btnBlock d-flex justify-content-end">
          <p-button
            [disabled]="workSpaceForm.invalid || preventAbuse"
            (click)="submit()"
            styleClass="updateBtn"
            label="Create New Workspace"
          ></p-button>
        </div>
      </div>
    </form>
  </app-loader>
</div>

<!--

<div class="workspacePopup">
  <ng-template pTemplate="header"></ng-template>
  <div class="trialCont">
    &lt;!&ndash; Image Section &ndash;&gt;
    <div class="img">
      <img src="/assets/images/html/trial.png" alt="Trial Expired Image" />
    </div>

    &lt;!&ndash; Content Section &ndash;&gt;
    <div class="textCont">
      <h1>Create Workspace</h1>
      <span
        data-toggle="tooltip"
        pTooltip="This will be billable. You can create a workspace where you can connect other accounts."
        tooltipPosition="top"
        role="button"
        ><i class="pi pi-info-circle info-icon"></i
      ></span>
      <p>What is workspace?</p>
      &lt;!&ndash; Buttons Section &ndash;&gt;
      <div class="actionButtons">
        &lt;!&ndash; Premium Plan Button &ndash;&gt;
        <app-loader [isLoading]="preventAbuse">
          <form [formGroup]="workSpaceForm">
            <p-message *ngIf="errorMessage" severity="error" text="{{ errorMessage }}"></p-message>
            <div class="userForm">
              <div class="inputWrap">
                <label for="">Workspace Name</label>
                <input
                  formControlName="workspace"
                  class="inputText"
                  type="text"
                  pInputText
                />
              </div>
              <div class="btnBlock d-flex justify-content-end">
                <p-button
                  [disabled]="workSpaceForm.invalid || preventAbuse"
                  (click)="submit()"
                  styleClass="updateBtn"
                  label="Create new workspace"
                ></p-button>
              </div>
            </div>
          </form>
        </app-loader>
      </div>
    </div>
  </div>
</div>
-->
